var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ListComponent',{ref:"list",attrs:{"api-route":'jobs',"favourites-key":'agency-jobs',"search-field":'customerName',"search-field-label":"Search Customer","warn":_vm.warn,"filter-options":_vm.filterOptions,"available-columns":_vm.availableColumns,"default-columns":_vm.defaultColumns,"actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }